import React, { useEffect, useState } from 'react';

import { TextField } from '@mui/material';

const FIELD_CHANGE_DEBOUNCE_MS = 250;

interface Props {
  ariaLabel: string;
  value?: number;
  onChange: (value?: number) => void;
}

export default function NumberField({ ariaLabel, onChange, value }: Props) {
  const [draftValue, setDraftValue] = useState(value?.toString() ?? '');

  useEffect(() => {
    setDraftValue(value?.toString() ?? '');
  }, [value]);

  useEffect(() => {
    const nextValue = draftValue === '' ? undefined : Number(draftValue);

    if (draftValue !== '' && !Number.isFinite(nextValue)) {
      return undefined;
    }

    if (nextValue === value) {
      return undefined;
    }

    const debounceTimer = window.setTimeout(() => {
      onChange(nextValue);
    }, FIELD_CHANGE_DEBOUNCE_MS);

    return () => window.clearTimeout(debounceTimer);
  }, [draftValue, onChange, value]);

  return (
    <TextField
      slotProps={{ htmlInput: { 'aria-label': ariaLabel, min: 0, step: 1 } }}
      onChange={(event) => setDraftValue(event.target.value)}
      size="small"
      type="number"
      value={draftValue}
      sx={{ minWidth: 130 }}
      fullWidth
    />
  );
}
